var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.6 4C4.71634 4 4 4.71634 4 5.6V9.6C4 10.4837 4.71634 11.2 5.6 11.2H9.6C10.4837 11.2 11.2 10.4837 11.2 9.6V5.6C11.2 4.71634 10.4837 4 9.6 4H5.6ZM5.6 5.6H9.6V9.6H5.6V5.6Z",
    fill: "#262626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.6 12.8C4.71634 12.8 4 13.5163 4 14.4V18.4C4 19.2837 4.71634 20 5.6 20H9.6C10.4837 20 11.2 19.2837 11.2 18.4V14.4C11.2 13.5163 10.4837 12.8 9.6 12.8H5.6ZM5.6 14.4H9.6V18.4H5.6V14.4Z",
    fill: "#262626"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8 5.6C12.8 4.71634 13.5163 4 14.4 4H18.4C19.2837 4 20 4.71634 20 5.6V9.6C20 10.4837 19.2837 11.2 18.4 11.2H14.4C13.5163 11.2 12.8 10.4837 12.8 9.6V5.6ZM18.4 5.6H14.4V9.6H18.4V5.6Z",
    fill: "#262626"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4 12.8C13.5163 12.8 12.8 13.5163 12.8 14.4V18.4C12.8 19.2837 13.5163 20 14.4 20H18.4C19.2837 20 20 19.2837 20 18.4V14.4C20 13.5163 19.2837 12.8 18.4 12.8H14.4ZM14.4 14.4H18.4V18.4H14.4V14.4Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhoto);
export default __webpack_public_path__ + "static/media/icon_photo.674d4d0045f1b4d21c8cedbb85626b84.svg";
export { ForwardRef as ReactComponent };